import { render, staticRenderFns } from "./NflTeamStats.vue?vue&type=template&id=54073bb4&scoped=true&"
import script from "./NflTeamStats.vue?vue&type=script&lang=js&"
export * from "./NflTeamStats.vue?vue&type=script&lang=js&"
import style0 from "./NflTeamStats.vue?vue&type=style&index=0&id=54073bb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54073bb4",
  null
  
)

export default component.exports